// src/Medicalcase/components/Specialtyfilter/specialtyLabel.js
//
// Les spécialités restent en ANGLAIS comme VALEURS (envoyées à l'API et
// utilisées pour filtrer). Cette fonction ne sert qu'à l'AFFICHAGE.

export function getSpecialtyLabel(t, value) {
  if (value === undefined || value === null || value === "") return "";

  const dictionary = t("specialties", { returnObjects: true });

  if (
    dictionary &&
    typeof dictionary === "object" &&
    typeof dictionary[value] === "string"
  ) {
    return dictionary[value];
  }

  return String(value);
}